import React, { Component } from 'react'
import PropTypes from 'prop-types'

class EmptyForm extends Component {
	render() {
		const { plugin } = this.props
		return (
			<div>
				<p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                {this.props.saveButton()}
			</div>
		)
	}
}

EmptyForm.propTypes = {
	plugin: PropTypes.object.isRequired
}

export default EmptyForm
